import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import { AppBar, Toolbar, useTheme } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';

import { FiltersRibbon, TopRibbon } from './Ribbons';
import { HeaderPropTypes } from 'src/interfaces/iproptypes';
import { useSelector } from 'react-redux';
import { getBannerHeight } from 'src/utils/functions';
import { Box, useMediaQuery } from '@mui/material';
import { APP_BAR_Z_INDEX, HEADER_HEIGHT, sidebarWidth } from 'src/const';
import Asynchronous from './Ribbons/Asynchronous';

// const drawerWidth = 195;

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    position: 'fixed',
    backgroundColor: 'white',
  },
  content: {
    [theme.breakpoints.up(900)]: {
      paddingLeft: sidebarWidth + theme.spacing(3.5),
      transition: theme.transitions.create('padding', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
  },
  contentShift: {
    [theme.breakpoints.up(900)]: {
      paddingLeft: theme.spacing(8),
      transition: theme.transitions.create('padding', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
  },
}));

const Header = ({
  sidebarOpen,
  setSidebarOpen,
  search,
  logoutThunk,
  setCurrency,
  user,
  currency,
  setLoginModalOpen,
  filterOpen,
  toggleDrawer,
  dashboardState,
  setdashboardState,
  matches,
  filterApplied,
  handleMarketSidebarClick,
  setSubscriptionModalOpen,
  district,
  isUserVerified,
  rateLimitAlert,
  setRateLimitAlert,
  googleAutocompleteSessionToken,
  getGoogleAutocompleteSessionToken,
  clearGoogleAutocompleteSessionToken,
  googleAutocompleteSessionTokenTimeStamp,
  cachedSearchMarkets,
  appTourStep,
  updateShowAppTour,
  handleSidebarListItemClick,
  centerCoord,
  setCenterCoord,
  address,
  setAddress,
  dashboardLayoutView,
  openDemoBookingForm,
  setDemoFormHeadingFor,
  dummyMarket,
}: HeaderPropTypes) => {
  const classes = useStyles();
  const isTopBannerOpen = useSelector((state: any) => state.dashboard.isTopBannerOpen);
  const theme = useTheme();
  const isMobileBreakPointBanner = useMediaQuery(theme.breakpoints.down(630));
  const [isMobileSearchBarOpen, setIsMobileSearchBarOpen] = useState<boolean>(false);

  const SearchBar = (
    <Asynchronous
      search={search}
      showAlert={() => {}}
      notShowAlert={() => {}}
      setdashboardState={setdashboardState}
      matches={matches}
      user={user}
      district={district}
      isUserVerified={isUserVerified}
      rateLimitAlert={rateLimitAlert}
      setRateLimitAlert={setRateLimitAlert}
      googleAutocompleteSessionToken={googleAutocompleteSessionToken}
      getGoogleAutocompleteSessionToken={getGoogleAutocompleteSessionToken}
      clearGoogleAutocompleteSessionToken={clearGoogleAutocompleteSessionToken}
      googleAutocompleteSessionTokenTimeStamp={googleAutocompleteSessionTokenTimeStamp}
      cachedSearchMarkets={cachedSearchMarkets}
      appTourStep={appTourStep}
      closeMobileSearch={() => setIsMobileSearchBarOpen(false)}
    />
  );

  return (
    <AppBar
      className={clsx(classes.root, {
        [classes.content]: sidebarOpen,
        [classes.contentShift]: !sidebarOpen,
      })}
      style={{
        top: isTopBannerOpen ? getBannerHeight(isMobileBreakPointBanner) : 0,
        height: HEADER_HEIGHT,
        zIndex: APP_BAR_Z_INDEX,
      }}
    >
      <Toolbar>
        {!matches &&
          !dashboardState.showSettingsDashboard &&
          !dashboardState.showEstimatorDashboard &&
          !dashboardState.showDynamicPricingDashboard &&
          !dashboardState.showAdvancedDashboard &&
          !dashboardState.showSearchListingDashboard &&
          dashboardLayoutView != 'discovery' &&
          dashboardLayoutView != 'compare' && (
            <FiltersRibbon
              search={search}
              user={user}
              setdashboardState={setdashboardState}
              matches={matches}
              district={district}
              isUserVerified={isUserVerified}
              rateLimitAlert={rateLimitAlert}
              setRateLimitAlert={setRateLimitAlert}
              googleAutocompleteSessionToken={googleAutocompleteSessionToken}
              getGoogleAutocompleteSessionToken={getGoogleAutocompleteSessionToken}
              clearGoogleAutocompleteSessionToken={clearGoogleAutocompleteSessionToken}
              googleAutocompleteSessionTokenTimeStamp={googleAutocompleteSessionTokenTimeStamp}
              dashboardState={dashboardState}
              cachedSearchMarkets={cachedSearchMarkets}
              appTourStep={appTourStep}
              SearchBar={SearchBar}
            />
          )}

        {user && (
          <TopRibbon
            logoutThunk={logoutThunk}
            user={user}
            filterOpen={filterOpen}
            toggleDrawer={toggleDrawer}
            dashboardState={dashboardState}
            setSidebarOpen={setSidebarOpen}
            filterApplied={filterApplied}
            handleMarketSidebarClick={handleMarketSidebarClick}
            setSubscriptionModalOpen={setSubscriptionModalOpen}
            currency={currency}
            setCurrency={setCurrency}
            setLoginModalOpen={setLoginModalOpen}
            matches={matches}
            updateShowAppTour={updateShowAppTour}
            sidebarOpen={sidebarOpen}
            SearchBar={SearchBar}
            isMobileSearchBarOpen={isMobileSearchBarOpen}
            setIsMobileSearchBarOpen={setIsMobileSearchBarOpen}
            handleSidebarListItemClick={handleSidebarListItemClick}
            centerCoord={centerCoord}
            setCenterCoord={setCenterCoord}
            address={address}
            setAddress={setAddress}
            openDemoBookingForm={openDemoBookingForm}
            setDemoFormHeadingFor={setDemoFormHeadingFor}
            dummyMarket={dummyMarket}
          />
        )}
        {/* SEO LINKS */}
        <Box
          sx={{
            position: 'absolute',
            left: '-999999px',
          }}
        >
          <a href="https://airbtics.com">Airbnb Data</a>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

Header.propTypes = {
  logoutThunk: PropTypes.func,
};

export default Header;
